const constatns = {
  ocpbComplaintAPIUrl: "https://mgcomplaint-api.ocpb.go.th/",
  //ocpbComplaintAPIUrl: "https://api-test.ocpb.go.th/",
  //ocpbComplaintAPIUrl: "https://localhost:44394/",
  digtalIdAPIUrl: "https://oauth.ocpb.go.th/digital-api/",
  digtalIdOauthUrl: "https://oauth.ocpb.go.th/",
  ocpbOpenAPI: "https://portal.ocpb.go.th/open_api/",
  OAuthLogin: "https://portal.ocpb.go.th/",
  OAuthAPIUrl: "https://portal.ocpb.go.th/oauth/",

  ocpbComplaintUrl: "https://mgcomplaint.ocpb.go.th/",

  // digitalIdBackendUrl: "https://mgocpbID.ocpb.go.th/",
  digitalIdBackendUrl: "https://mgdigitalID.ocpb.go.th/",
  documentComplaintUrl: "https://dform.ocpb.go.th/",
  documentUrl:
    "https://dform.ocpb.go.th/document?docId={0}&Authen={1}&Redirecturl={2}&Redirectback={3}",
  documentUrlApprove:
    "https://dform.ocpb.go.th/documentApprove?docId={0}&Authen={1}&Redirecturl={2}&Redirectback={3}",
  complaintFormUrl:
    "https://dform.ocpb.go.th/CPForm?ID=Pettition&ComplaintId={0}&mode=1",
  complaintFormUrlBangkok:
    "https://dform.ocpb.go.th/CPForm?ID=Pettition&ComplaintId={0}&mode=0",
  complaintFormCancelUrl:
    "https://dform.ocpb.go.th/CPForm?ID=Terminate&ComplaintId={0}",
  dashboardTableau:
    "https://ocpbconnect.ocpb.go.th/ReportMobile?report_id=1C961F8C-E319-4FD0-83F4-B8E617344BAB",
  complaintSummaryReport:
    "https://dform.ocpb.go.th/CPForm/RptSendReceiveSummary/Report",
  complaintLoginCustomerByOfficer:
    "https://complaint.ocpb.go.th/sso/callback?storage=tracking&officer=",
  fasttrackLoginAttorneyByOfficer: "https://fasttrack.ocpb.go.th/sso/callback",
  provinceDepartmentId: "535e93cc-ad5a-488f-c410-08d86b48aba4",
  lawDepartmentId: "0351ca3f-4d3c-4fd0-b82e-5a5b0dc1e224",
  bangkokDepartmentId: "de73a2af-691f-417a-902a-fc08ab850d2a",
  complaintRoleId: {
    screening: "11857bdf-5691-45f1-823e-f5c3a6fd9ff4",
    admin: "9986f72b-d167-4532-8c27-4bc183ef5222",
    province: "25e8af7c-d072-47fd-985b-fb1eefc44764",
    area: "f222bebd-9f10-4832-bfdb-18cb0e0311a2",
    received: "cd9c65ce-31f3-4638-b4c9-041573d77067",
    secretary: "21bcabcd-e658-4e7e-8183-6e1a98cdd70a",
    bangkok: "fb3c1330-6e09-454c-93cc-15051d5bf18e",
  },
  oauthKey: {
    clientId: "00A272AA-F50D-42E1-B65B-FC51F05252C7",
  },
  oauthFasttrackKey: {
    clientId: "43E858F8-4D5D-4CF0-8DE7-6DBF7762F27C",
  },
  clueDepartmentID: {
    screening: "69D217CA-BD59-4D79-6DE3-08DC9B2BB3EF",
    screeningOld: "EF0357A1-C740-4680-91AB-51FA9131FBC1",
  },
  complaintdepartmentId: {
    screening: "69D217CA-BD59-4D79-6DE3-08DC9B2BB3EF",
    lawOfficer: "0351ca3f-4d3c-4fd0-b82e-5a5b0dc1e224",
  },
  complaintDownloadAttach:
    "https://dform.ocpb.go.th/CPForm/Download/DownloadAttach?complaintId={0}&attachId={1}",
};

export default constatns;
